import gql from "graphql-tag";

export const SPACE_DESTROY = gql`
  mutation SpaceDelete($id: ID!) {
    spaceDelete(id: $id) {
      ok
    }
  }
`;
